import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaCheck, FaWhatsapp } from "react-icons/fa";
import Tilty from 'react-tilty';

const whatsappDemoUrl = "https://wa.me/5214494130113?text=Hola%2C%20me%20gustar%C3%ADa%20solicitar%20una%20demo%20de%20Softweb.";

const BannerFour = ({ onNavigate }) => {

    const navigate = useNavigate();
    
    const handleNavigate = (event, section, extra = {}) => {

        event.preventDefault();

        // Si estamos en HomeStartup, usamos el comportamiento actual.
        if (typeof onNavigate === 'function') {
            onNavigate(section, extra);
            return;
        }

        // Si estamos en otra página, regresamos al Home.
        navigate(
            `${process.env.PUBLIC_URL}/#${section}`,
            {
                state: extra
            }
        );
    };

    return (
        <div className="banner banner-style-4">
            <div className="container">
                <div className="banner-content banner-softweb-content">
                    <span className="banner-eyebrow">TODO TU NEGOCIO, EN UN SOLO LUGAR</span>
                    <h1 className="title">El sistema que impulsa tu negocio.</h1>
                    <p className="subtitle">
                        Gestiona facturación, nómina y ventas con una plataforma simple,
                        ágil y lista para crecer contigo.
                    </p>
                    <div className='btn-group'>
                        <button
                            type="button"
                            className="axil-btn btn-fill-primary btn-large"
                            onClick={(event) => handleNavigate(event, 'planes')}
                        >
                            Ver planes
                        </button>
                        <a href={whatsappDemoUrl} className="axil-btn btn-fill-gray btn-large" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp aria-hidden="true" /> Solicita una demo
                        </a>
                    </div>
                    <ul className="banner-benefits list-unstyled" aria-label="Beneficios de Softweb">
                        <li><FaCheck aria-hidden="true" /> Facturación y CFDI 4.0</li>
                        <li><FaCheck aria-hidden="true" /> Soporte personalizado en México</li>
                        <li><FaCheck aria-hidden="true" /> Implementación rápida</li>
                    </ul>
                </div>
                <div className="banner-thumbnail">
                    <div className="large-thumb">
                        <Tilty perspective={3000}>
                            <img
                                src={process.env.PUBLIC_URL + "/images/banner/nuevoSoftweb.png"}
                                alt="Panel principal del sistema Softweb"
                                width={1085}
                                height={845}
                            />
                        </Tilty>
                    </div>
                </div>
            </div>
            <ul className="list-unstyled shape-group-19">
                <li className="shape shape-1">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-29.png"} alt="Bubble" />
                </li>
                <li className="shape shape-2">
                    <img src={process.env.PUBLIC_URL + "/images/others/line-7.png"} alt="Bubble" />
                </li>
            </ul>
        </div>
    )
}

export default BannerFour;
